import { trpc } from "@lango/api";
import { useEffect } from "react";

export const useBots = () => {
  const ctx = trpc.useContext();
  const { data, isLoading } = trpc.bots.useQuery();

  useEffect(() => {
    if (!data) {
      return;
    }
    data.forEach((bot) => {
      ctx.getBot.setData({ id: bot.id }, bot);
    });
  }, [data]);

  return {
    data,
    isLoading,
  };
};
